import { commentItems } from '@/mocks/homepage';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">读者之声</h2>
          <p className="text-sm text-foreground-500">来自喵趣读者的真实评价</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg p-5 border border-background-200/80"
            >
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover"
                  width="40"
                  height="40"
                  loading="lazy"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {item.content}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-primary-600 bg-primary-100/60 px-2 py-0.5 rounded-full">
                  {item.comic}
                </span>
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-heart-line text-primary-500"></i>
                  {item.likes}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}